const organization = {
    require_membership: 'Kullanıcının devam etmek için organizasyonun bir üyesi olması gerekir.',
};
export default Object.freeze(organization);
